import TableCell from './TableCell';

export default TableCell;
